// apps/web/src/features/dashboards/china-requests/RefusalReasons.tsx (#1589, #2166)
// Refusal-reason breakdown, sorted by count desc, rendered as a horizontal
// `BarChartView` (#2163). Reason copy is reused from the
// `requests:refuseModal.reason.*` keys (no new strings).
import { useMemo } from 'react';
import type { ChinaRequestsDashboardSummary } from '@magimp/shared';
import { BarChartView } from '../../../ui/index.js';
import { REFUSAL_REASON_LABEL_KEYS } from './labels.js';
import { SECTION_CARD, type DashboardT } from './section.js';

interface RefusalReasonsProps {
  refusalReasons: ChinaRequestsDashboardSummary['refusalReasons'];
  t: DashboardT;
}

export function RefusalReasons({ refusalReasons, t }: RefusalReasonsProps) {
  const sorted = useMemo(
    () => [...refusalReasons].sort((a, b) => b.count - a.count),
    [refusalReasons],
  );

  if (sorted.length === 0) return null;

  const series = sorted.map((entry) => ({
    key: String(entry.reason),
    label: t(`requests:${REFUSAL_REASON_LABEL_KEYS[entry.reason]}`),
    value: entry.count,
  }));

  return (
    <section style={{ ...SECTION_CARD, display: 'flex', flexDirection: 'column', gap: 8 }}>
      <div style={{ fontSize: 13, fontWeight: 600 }}>
        {t('dashboards:chinaRequests.refusal.title')}
      </div>
      <div data-testid="china-requests-refusal">
        <BarChartView
          series={series}
          orientation="horizontal"
          seriesLabel={t('dashboards:chinaRequests.refusal.countHeader')}
          xAxisLabel={t('dashboards:chinaRequests.refusal.reasonHeader')}
          ariaLabel={t('dashboards:chinaRequests.refusal.title')}
        />
      </div>
    </section>
  );
}
